import { Injectable } from '@angular/core';
import { SizeWindow } from '../enums/size-window';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SizeWindowService {

  sizeWindow: string = "";

  SizeWindow_InProgress: { outerWidth: number, innerHeight: number, sizeWindow: SizeWindow, sizeWindowNumber: number, sizeWindowText: string} = { outerWidth: 0, innerHeight: 0, sizeWindow: SizeWindow.SM, sizeWindowNumber: 0, sizeWindowText: ""}

  constructor() { }

  /**************************************************** Config Observable ****************************************************************************************/

	public configObservableSizeWindow = new Subject<{ outerWidth: number, innerHeight: number, sizeWindow: SizeWindow, sizeWindowNumber: number, sizeWindowText: string}>();

	emitSizeWindow(getSizeWindow: { outerWidth: number, innerHeight: number, sizeWindow: SizeWindow, sizeWindowNumber: number, sizeWindowText: string}) {
		this.configObservableSizeWindow.next(getSizeWindow);
	}

  /*****************************************************************************************************************************************************/

  findSizeWindow(outerWidth: number, innerHeight: number) {
    // https://www.viewsonic.com/library/fr/tech-fr/resolution-decran-et-format-dimage/#:~:text=Celle%2Dci%20renseigne%20sur%20la,largeur%20et%201080%20en%20hauteur.

    console.log(outerWidth, innerHeight)

    let sizeWindow: string = "";
    if ((outerWidth <= 7680) && (outerWidth > 3840)) {
      sizeWindow = "8K_custom"
      if ((innerHeight <= 4320) && (innerHeight > 2160)) {
        sizeWindow = "8K";
      }
    } else if ((outerWidth <= 3840) && (outerWidth > 2560)) {
      sizeWindow = "4K_custom"
      if ((innerHeight <= 2160) && (innerHeight > 1600)) {
        sizeWindow = "4K";
      }
    } else if ((outerWidth <= 2560) && (outerWidth > 1920)) {
      sizeWindow = "1600p_custom"
      if ((innerHeight <= 1600) && (innerHeight > 1440)) {
        sizeWindow = "1600p";
      }

      if ((innerHeight <= 1440) && (innerHeight > 1200)) {
        sizeWindow = "1440p";
      }
    } else if ((outerWidth <= 1920) && (outerWidth > 1280)) {
      sizeWindow = "1200p_custom"
      if ((innerHeight <= 1200) && (innerHeight > 1080)) {
        sizeWindow = "1200p";
      }

      if ((innerHeight <= 1080) && (innerHeight > 800)) {
        sizeWindow = "1080p";
      }
    } else if (outerWidth == 1280) {
      sizeWindow = "800p_custom"
      if ((innerHeight <= 800) && (innerHeight > 720)) {
        sizeWindow = "800p";
      } else {
        sizeWindow = "720p";
      }
    } else if ((outerWidth < 1280) && (outerWidth >= 640)) {
      sizeWindow = "mobile_sm";
    } else {
      sizeWindow = "mobile_xs";
    }
    console.log(sizeWindow)
    this.sizeWindow = sizeWindow;

    let numberSize = this.getNumberSize(this.sizeWindow);

    this.emitSizeWindow(this.SizeWindow_InProgress = { outerWidth: outerWidth, innerHeight: innerHeight, sizeWindow: this.getSizeEnum(numberSize), sizeWindowNumber: numberSize, sizeWindowText: this.sizeWindow});
  }

  getNumberSize(sizeWindowText: string): number {
    switch(sizeWindowText) {
      case '8K_custom':
        return 14;
      case '8K':
          return 13;
      case '4K_custom':
        return 12;
      case '4K':
          return 11;
      case '1600p_custom':
        return 10;
      case '1600p':
          return 9;
      case '1440p':
        return 8;
      case '1200p_custom':
          return 7
      case '1200p':
        return 6;
      case '1080p':
          return 5;
      case '800p_custom':
        return 4;
      case '800p':
          return 3;
      case '720p':
        return 2;
      case 'mobile_sm':
        return 1;
      default:
        return 0;
    }
  }

  getSizeEnum(sizeWindowText: number): SizeWindow {
    if (sizeWindowText <= 1 && sizeWindowText > 0) {
      return SizeWindow.SM; 
    } else if (sizeWindowText <= 7 && sizeWindowText > 1) {
      return SizeWindow.MD;
    } else if (sizeWindowText <= 9 && sizeWindowText > 7) {
      return SizeWindow.LG;
    } else if (sizeWindowText <= 11 && sizeWindowText > 9) {
      return SizeWindow.XL;
    } else if (sizeWindowText <= 14 && sizeWindowText > 11) {
      return SizeWindow.XXL;
    } else {
      return SizeWindow.XS;
    }
  }
}
